import { render } from "./HelloWorld.vue?vue&type=template&id=eb63751e&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=eb63751e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb63751e"

export default script